import React from 'react';
import radium from 'radium';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

function SponsorLogos() {
	const context = React.useContext(ThemeContext);
	const imageSrcString = context.themeManager.value('sponsors', 'logos', null);
	const imageLinkString = context.themeManager.value('sponsors', 'urls', null);
	const imageAltString = context.themeManager.value('sponsors', 'alt', null);
	const imageSrc = imageSrcString ? imageSrcString.split('|') : [];
	const imageLink = imageLinkString ? imageLinkString.split('|') : [];
	const imageAlt = imageAltString ? imageAltString.split('|') : [];
	const style = {
		containerOuter: {
			display: 'flex',
			flexWrap: 'wrap',
			padding: '2em 0 4em 0',
			justifyContent: 'center',
		},
		container: {
			width: context.themeManager.valueOrDefault('sponsors', 'imageWidth', null, '100%'),
			display: 'flex',
			justifyContent: 'center',
			padding: '0 1em'
		},
		image: {
			objectFit: 'scale-down',
			maxWidth: '100%'
		},
		imageLink: {
			alignItems: 'center',
			display: 'flex'
		}
	};
	return (
		<div>
			{imageSrc.length > 0 &&
			<div style={style.containerOuter}>
				{imageSrc.map((src, index) =>
					<div style={style.container} key={index}>
						{imageLink[index] ?
							<a href={imageLink[index]} title={imageAlt[index] ? imageAlt[index] : ''} style={style.imageLink}>
								<img src={src} key={index} style={style.image} alt={imageAlt[index]}/>
							</a>
							:	<img src={src} key={index} style={style.image} alt={imageAlt[index] ? imageAlt[index] : `Logo Sponsor ${index}`}/>
						}
					</div>
				)}
			</div>
			}
		</div>);
}

export default radium(SponsorLogos);
